var map = {
	"./achieving-efficiency.svg": [
		56516,
		56516
	],
	"./add-specialist.svg": [
		12739,
		12739
	],
	"./adjustment-of-indicators.svg": [
		24846,
		24846
	],
	"./affordable-advantages.svg": [
		69487,
		69487
	],
	"./all.svg": [
		43647,
		43647
	],
	"./andersen-logo.svg": [
		69414,
		69414
	],
	"./andersen-mobile.svg": [
		43989,
		43989
	],
	"./android-devices.svg": [
		37425,
		37425
	],
	"./android-tablets.svg": [
		24459,
		24459
	],
	"./animation.svg": [
		31492,
		31492
	],
	"./app-design.svg": [
		7442,
		7442
	],
	"./application-problems.svg": [
		86337,
		86337
	],
	"./application.svg": [
		14460,
		14460
	],
	"./architecture.svg": [
		77267,
		77267
	],
	"./arrow.svg": [
		1097,
		1097
	],
	"./artificial-intelligence.svg": [
		66930,
		66930
	],
	"./as.svg": [
		60350,
		60350
	],
	"./avoiding-delays.svg": [
		81272,
		81272
	],
	"./aws-business-analytics.svg": [
		64291,
		64291
	],
	"./aws-cloud-development.svg": [
		50665,
		50665
	],
	"./aws-devops.svg": [
		77473,
		77473
	],
	"./aws-migration.svg": [
		5714,
		5714
	],
	"./back-end-icon.svg": [
		99323,
		99323
	],
	"./behance-circle.svg": [
		79403,
		79403
	],
	"./betting-online.svg": [
		4161,
		4161
	],
	"./betting-pari-mutuel.svg": [
		95963,
		95963
	],
	"./betting-platform.svg": [
		77017,
		77017
	],
	"./betting-sports-solutions.svg": [
		49594,
		49594
	],
	"./betting-sports.svg": [
		59417,
		59417
	],
	"./betting-support.svg": [
		64517,
		64517
	],
	"./big-data-solutions.svg": [
		70046,
		70046
	],
	"./billing-processes.svg": [
		30391,
		30391
	],
	"./blockchain-transparency.svg": [
		81315,
		81315
	],
	"./business-analysis.svg": [
		23239,
		23239
	],
	"./business-in-the-project.svg": [
		54074,
		54074
	],
	"./business.svg": [
		63012,
		63012
	],
	"./calculator.svg": [
		63570,
		63570
	],
	"./calendar-3.svg": [
		34916,
		34916
	],
	"./capital-markets.svg": [
		13718,
		13718
	],
	"./care-coordination.svg": [
		70791,
		70791
	],
	"./cart.svg": [
		28836,
		28836
	],
	"./certified-team.svg": [
		24321,
		24321
	],
	"./cheap.svg": [
		15299,
		15299
	],
	"./check-mark.svg": [
		31396,
		31396
	],
	"./check.svg": [
		30946,
		30946
	],
	"./checked-calendar.svg": [
		13856,
		13856
	],
	"./clip.svg": [
		53552,
		53552
	],
	"./close.svg": [
		35326,
		35326
	],
	"./cloud-storage.svg": [
		83597,
		83597
	],
	"./clutch.svg": [
		83169,
		83169
	],
	"./communication-processes.svg": [
		51538,
		51538
	],
	"./communication.svg": [
		35458,
		35458
	],
	"./comparison.svg": [
		63461,
		63461
	],
	"./compliance.svg": [
		69939,
		69939
	],
	"./consistent-understanding.svg": [
		62787,
		62787
	],
	"./control-and-reporting.svg": [
		14536,
		14536
	],
	"./control-of-depression.svg": [
		87990,
		87990
	],
	"./controls-alt.svg": [
		18238,
		18238
	],
	"./cost-limitation.svg": [
		17634,
		17634
	],
	"./cost-optimization.svg": [
		11865,
		11865
	],
	"./cost-savings.svg": [
		92071,
		92071
	],
	"./custom-decision-support-software.svg": [
		76894,
		76894
	],
	"./custom-loan-management-system.svg": [
		33120,
		33120
	],
	"./custom-solutions.svg": [
		32436,
		32436
	],
	"./customized-management.svg": [
		86747,
		86747
	],
	"./data-capture.svg": [
		27079,
		27079
	],
	"./data-monitoring.svg": [
		13657,
		13657
	],
	"./data-safety-and-scalability.svg": [
		76363,
		76363
	],
	"./delivering-care.svg": [
		80219,
		80219
	],
	"./design-projects.svg": [
		52215,
		52215
	],
	"./desktop-and-mobile-checked.svg": [
		6069,
		6069
	],
	"./diagnosis.svg": [
		40361,
		40361
	],
	"./digital-product.svg": [
		84856,
		84856
	],
	"./discovery.svg": [
		22272,
		22272
	],
	"./display-and-mobile-with-dollar.svg": [
		36027,
		36027
	],
	"./display-tag.svg": [
		4515,
		4515
	],
	"./document-with-checked-items.svg": [
		13885,
		13885
	],
	"./dribbble.svg": [
		61484,
		61484
	],
	"./eco-friendly.svg": [
		99391,
		99391
	],
	"./education.svg": [
		340,
		340
	],
	"./efficiency.svg": [
		85665,
		85665
	],
	"./egress.svg": [
		83255,
		83255
	],
	"./elderly-health.svg": [
		69886,
		69886
	],
	"./enjoyable.svg": [
		44519,
		44519
	],
	"./enterprise.svg": [
		35847,
		35847
	],
	"./f500.svg": [
		74261,
		74261
	],
	"./facebook-circle.svg": [
		14627,
		14627
	],
	"./facebook-round.svg": [
		33305,
		33305
	],
	"./feature-favorite.svg": [
		53373,
		53373
	],
	"./fintech.svg": [
		35341,
		35341
	],
	"./flexibility.svg": [
		97319,
		97319
	],
	"./folders-with-gear-checked.svg": [
		76990,
		76990
	],
	"./front-end-icon.svg": [
		53703,
		53703
	],
	"./fullscreen-exit.svg": [
		98206,
		98206
	],
	"./fullscreen.svg": [
		5793,
		5793
	],
	"./functionality-issues.svg": [
		71044,
		71044
	],
	"./game-development.svg": [
		42408,
		42408
	],
	"./gear-checked.svg": [
		56583,
		56583
	],
	"./gear-to-cross.svg": [
		78392,
		78392
	],
	"./gear-with-cross.svg": [
		80443,
		80443
	],
	"./general-processes.svg": [
		20666,
		20666
	],
	"./globe-3.svg": [
		26161,
		26161
	],
	"./graphic-design.svg": [
		75845,
		75845
	],
	"./handling-mess.svg": [
		12786,
		12786
	],
	"./health-control.svg": [
		90188,
		90188
	],
	"./health-information.svg": [
		61837,
		61837
	],
	"./health-records.svg": [
		64329,
		64329
	],
	"./healthcare-accuracy-of-information.svg": [
		1254,
		1254
	],
	"./healthcare-better-outcomes.svg": [
		24648,
		24648
	],
	"./healthcare-billing-errors.svg": [
		63351,
		63351
	],
	"./healthcare-billing-processes.svg": [
		64701,
		64701
	],
	"./healthcare-chronic-management.svg": [
		85338,
		85338
	],
	"./healthcare-claims-scrubbing.svg": [
		93903,
		93903
	],
	"./healthcare-cost-control.svg": [
		26887,
		26887
	],
	"./healthcare-decreased-workload.svg": [
		88678,
		88678
	],
	"./healthcare-easy-registration.svg": [
		61268,
		61268
	],
	"./healthcare-improper-monitoring.svg": [
		4835,
		4835
	],
	"./healthcare-integrated-healthcare.svg": [
		85021,
		85021
	],
	"./healthcare-poor-interoperability.svg": [
		4525,
		4525
	],
	"./healthcare-realtime-access.svg": [
		12142,
		12142
	],
	"./healthcare-regulatory-compliance.svg": [
		91962,
		91962
	],
	"./healthcare-smart-utilization.svg": [
		77152,
		77152
	],
	"./healthcare-symptom-detection.svg": [
		29367,
		29367
	],
	"./healthcare-timely-intervention.svg": [
		36516,
		36516
	],
	"./healthcare-timely-reimbursements.svg": [
		70636,
		70636
	],
	"./healthcare.svg": [
		58711,
		58711
	],
	"./healthcare_experience.svg": [
		23530,
		23530
	],
	"./high-operational-expences.svg": [
		68877,
		68877
	],
	"./hint.svg": [
		56145,
		56145
	],
	"./human-centered-design.svg": [
		40133,
		40133
	],
	"./hybrid-apps.svg": [
		15981,
		15981
	],
	"./igaming.svg": [
		88312,
		88312
	],
	"./illustrations.svg": [
		66007,
		66007
	],
	"./improved-access.svg": [
		65821,
		65821
	],
	"./improved-roi.svg": [
		25307,
		25307
	],
	"./improved-safety.svg": [
		50569,
		50569
	],
	"./improving-diagnoses.svg": [
		63823,
		63823
	],
	"./info-icon.svg": [
		13548,
		13548
	],
	"./input-for-future-projects.svg": [
		73231,
		73231
	],
	"./insecure-sharing.svg": [
		93239,
		93239
	],
	"./instagram-circle.svg": [
		66319,
		66319
	],
	"./integration-services.svg": [
		92065,
		92065
	],
	"./integration.svg": [
		23784,
		23784
	],
	"./integrations.svg": [
		69979,
		69979
	],
	"./interactive-websites.svg": [
		317,
		317
	],
	"./internet-of-things.svg": [
		84909,
		84909
	],
	"./ioT-app-development.svg": [
		92740,
		92740
	],
	"./ioT-data-analytics.svg": [
		26268,
		26268
	],
	"./ioT-database-solutions.svg": [
		95287,
		95287
	],
	"./ioT.svg": [
		80066,
		80066
	],
	"./ios-devices.svg": [
		98395,
		98395
	],
	"./ios-tablets.svg": [
		43081,
		43081
	],
	"./it-project-management.svg": [
		49611,
		49611
	],
	"./it-sa.svg": [
		61234,
		61234
	],
	"./it-services.svg": [
		45882,
		45882
	],
	"./legacy-modern.svg": [
		72509,
		72509
	],
	"./letter-success.svg": [
		73600,
		73600
	],
	"./linkedin-circle.svg": [
		55825,
		55825
	],
	"./linkedin-round.svg": [
		47771,
		47771
	],
	"./linkedin-square.svg": [
		25204,
		25204
	],
	"./long-life.svg": [
		29559,
		29559
	],
	"./loupe-left-side.svg": [
		11961,
		11961
	],
	"./mail.svg": [
		95343,
		95343
	],
	"./man-2-strong.svg": [
		53661,
		53661
	],
	"./man-2.svg": [
		12543,
		12543
	],
	"./man-with-cross.svg": [
		26356,
		26356
	],
	"./management.svg": [
		53399,
		53399
	],
	"./manual-filling.svg": [
		5382,
		5382
	],
	"./map-marker.svg": [
		98831,
		98831
	],
	"./mark-of-distinction.svg": [
		94444,
		94444
	],
	"./marker-filled.svg": [
		12625,
		12625
	],
	"./medical-data.svg": [
		54872,
		54872
	],
	"./medical-errors.svg": [
		25837,
		25837
	],
	"./medical-knowledge.svg": [
		81540,
		81540
	],
	"./medical-resources.svg": [
		30447,
		30447
	],
	"./mental-wellbeing.svg": [
		36591,
		36591
	],
	"./minus.svg": [
		54366,
		54366
	],
	"./mitigated-risks.svg": [
		77615,
		77615
	],
	"./mobile-app-design.svg": [
		75949,
		75949
	],
	"./mobile-dev-icon.svg": [
		92196,
		92196
	],
	"./mobile-friendly-web-design.svg": [
		5972,
		5972
	],
	"./modern-tech.svg": [
		10380,
		10380
	],
	"./monitoring.svg": [
		21344,
		21344
	],
	"./more.svg": [
		41653,
		41653
	],
	"./motion-design.svg": [
		77011,
		77011
	],
	"./multicloud.svg": [
		44844,
		44844
	],
	"./multilevel.svg": [
		12829,
		12829
	],
	"./mvp.svg": [
		47133,
		47133
	],
	"./no-matching-results.svg": [
		32172,
		32172
	],
	"./non-engineering.svg": [
		87765,
		87765
	],
	"./open.svg": [
		10242,
		10242
	],
	"./operational-excellence.svg": [
		89853,
		89853
	],
	"./order.svg": [
		34842,
		34842
	],
	"./partnership.svg": [
		27030,
		27030
	],
	"./pause.svg": [
		47792,
		47792
	],
	"./pen-2.svg": [
		59950,
		59950
	],
	"./performance-efficiency.svg": [
		13562,
		13562
	],
	"./personal-data-secure.svg": [
		26463,
		26463
	],
	"./personal-health.svg": [
		70897,
		70897
	],
	"./phone-filled.svg": [
		84263,
		84263
	],
	"./php-api-development-services.svg": [
		99774,
		99774
	],
	"./php-code-audits-and-reporting.svg": [
		59296,
		59296
	],
	"./php-e-commerce-development.svg": [
		90032,
		90032
	],
	"./php-web-development-services.svg": [
		7648,
		7648
	],
	"./planning.svg": [
		38677,
		38677
	],
	"./play-triangle.svg": [
		10033,
		10033
	],
	"./plus-mini.svg": [
		71430,
		71430
	],
	"./plus.svg": [
		15798,
		15798
	],
	"./point-of-access.svg": [
		13969,
		13969
	],
	"./price-reduction.svg": [
		47137,
		47137
	],
	"./process-automation.svg": [
		97575,
		97575
	],
	"./product-centered-approach.svg": [
		62037,
		62037
	],
	"./product-design.svg": [
		28354,
		28354
	],
	"./product-development-services.svg": [
		64972,
		64972
	],
	"./product-quality.svg": [
		70203,
		70203
	],
	"./protected-privacy.svg": [
		24463,
		24463
	],
	"./proven-experience.svg": [
		16903,
		16903
	],
	"./push-notifications.svg": [
		91441,
		91441
	],
	"./puzzle.svg": [
		22278,
		22278
	],
	"./qa-audit.svg": [
		92294,
		92294
	],
	"./quality-of-care.svg": [
		31145,
		31145
	],
	"./quality-predictability.svg": [
		48909,
		48909
	],
	"./quick-launch.svg": [
		68693,
		68693
	],
	"./redesign-services.svg": [
		67940,
		67940
	],
	"./relationship.svg": [
		52084,
		52084
	],
	"./remote-patient.svg": [
		2300,
		2300
	],
	"./reporting-documentation.svg": [
		32765,
		32765
	],
	"./resources.svg": [
		91621,
		91621
	],
	"./revenue-cycle.svg": [
		26623,
		26623
	],
	"./risk-reduction.svg": [
		65355,
		65355
	],
	"./saas-app-development.svg": [
		5892,
		5892
	],
	"./saas-consulting-services.svg": [
		66064,
		66064
	],
	"./saas-migration.svg": [
		55093,
		55093
	],
	"./saas-security-management.svg": [
		92679,
		92679
	],
	"./saas-support.svg": [
		6276,
		6276
	],
	"./salary.svg": [
		62024,
		62024
	],
	"./scalability.svg": [
		13975,
		13975
	],
	"./scrubbing-statements.svg": [
		62168,
		62168
	],
	"./seamless-transformation.svg": [
		88447,
		88447
	],
	"./security.svg": [
		73048,
		73048
	],
	"./self-care.svg": [
		9450,
		9450
	],
	"./shield-with-dollar.svg": [
		17201,
		17201
	],
	"./small-arrow.svg": [
		62891,
		62891
	],
	"./smart-tv.svg": [
		37044,
		37044
	],
	"./smes.svg": [
		92058,
		92058
	],
	"./social-responsible.svg": [
		29840,
		29840
	],
	"./software.svg": [
		19061,
		19061
	],
	"./specialist.svg": [
		71905,
		71905
	],
	"./staff.svg": [
		21532,
		21532
	],
	"./start.svg": [
		5474,
		5474
	],
	"./startup.svg": [
		86457,
		86457
	],
	"./startups-software.svg": [
		14106,
		14106
	],
	"./startups-strategic-business.svg": [
		48016,
		48016
	],
	"./state-assessments.svg": [
		53019,
		53019
	],
	"./strategy.svg": [
		60141,
		60141
	],
	"./stress-testing.svg": [
		99025,
		99025
	],
	"./study.svg": [
		33313,
		33313
	],
	"./supply-chain.svg": [
		9491,
		9491
	],
	"./support-cloud.svg": [
		85219,
		85219
	],
	"./support-ground-up.svg": [
		30581,
		30581
	],
	"./support-infrastructure.svg": [
		22493,
		22493
	],
	"./support-level-three.svg": [
		99013,
		99013
	],
	"./support-product.svg": [
		23813,
		23813
	],
	"./support.svg": [
		37551,
		37551
	],
	"./survey.svg": [
		62144,
		62144
	],
	"./system-automation-services.svg": [
		54556,
		54556
	],
	"./talents.svg": [
		35083,
		35083
	],
	"./team.svg": [
		67517,
		67517
	],
	"./technology.svg": [
		6620,
		6620
	],
	"./telecom.svg": [
		65293,
		65293
	],
	"./telemedicine.svg": [
		94338,
		94338
	],
	"./teleradiology.svg": [
		45592,
		45592
	],
	"./testing-automation.svg": [
		96046,
		96046
	],
	"./testing-process.svg": [
		75406,
		75406
	],
	"./tight-deadlines.svg": [
		69670,
		69670
	],
	"./time-line.svg": [
		81852,
		81852
	],
	"./timeliness.svg": [
		87737,
		87737
	],
	"./timely.svg": [
		65712,
		65712
	],
	"./trading.svg": [
		49765,
		49765
	],
	"./training.svg": [
		93180,
		93180
	],
	"./treatment.svg": [
		59354,
		59354
	],
	"./tsd.svg": [
		29147,
		29147
	],
	"./twitter-round.svg": [
		97468,
		97468
	],
	"./uiux-design.svg": [
		4282,
		4282
	],
	"./unclear-protocols.svg": [
		26102,
		26102
	],
	"./union.svg": [
		24967,
		24967
	],
	"./unusable-toolkit.svg": [
		63190,
		63190
	],
	"./upgradation-services.svg": [
		58557,
		58557
	],
	"./usability-audit.svg": [
		53062,
		53062
	],
	"./video-play-circle.svg": [
		23139,
		23139
	],
	"./views.svg": [
		42988,
		42988
	],
	"./virus-protection.svg": [
		54859,
		54859
	],
	"./visual-identity.svg": [
		64761,
		64761
	],
	"./volume-off.svg": [
		59676,
		59676
	],
	"./volume.svg": [
		97528,
		97528
	],
	"./warning.svg": [
		98486,
		98486
	],
	"./web-design.svg": [
		20719,
		20719
	],
	"./welfare-of-employees.svg": [
		49368,
		49368
	],
	"./women-health.svg": [
		91935,
		91935
	],
	"./x-ray-photo.svg": [
		66122,
		66122
	],
	"./xing-circle.svg": [
		95823,
		95823
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70809;
module.exports = webpackAsyncContext;